import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGaurd } from './shared/services/auth.gaurd';
import { BlankLayoutComponent } from './shared/components/layouts/blank-layout/blank-layout.component';
import { AdminLayoutSidebarCompactComponent } from './shared/components/layouts/admin-layout-sidebar-compact/admin-layout-sidebar-compact.component';

const adminRoutes: Routes = [
    {
      path: 'home',
      loadChildren: () => import('./views/services/services.module').then(m => m.ServicesModule)
    },
    {
      path: 'services',
      loadChildren: () => import('./views/services/services.module').then(m => m.ServicesModule)
    },
    {
      path: 'transfert',
      loadChildren: () => import('./views/transferts/transferts.module').then(m => m.TransfertsModule)
    },
    {
      path: 'rechargement',
      loadChildren: () => import('./views/rechargement/rechargement.module').then(m => m.RechargementModule)
    },
    {
      path: 'achat',
      loadChildren: () => import('./views/achat-service/achat-service.module').then(m => m.AchatServiceModule)
    },
    {
      path: 'paiement',
      loadChildren: () => import('./views/paiement/paiement.module').then(m => m.PaiementModule)
    },
    {
      path: 'profil',
      loadChildren: () => import('./views/profil/profil.module').then(m => m.ProfilModule)
    },
   
  ];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'sessions',
        loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule)
      }
    ]
  },
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: 'others',
        loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule)
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutSidebarCompactComponent,
    canActivate: [AuthGaurd],
    children: adminRoutes
  },
  {
    path: '**',
    redirectTo: 'others/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
